import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TextField, Checkbox, TableSortLabel, InputAdornment, Button } from '@material-ui/core';
import { StyledTableCell } from '.';

function EnhancedTableHead(props) {
    const {
        columns,
        classes,
        order,
        orderBy,
        onRequestSort,
        filtros,
        DetailByrow,
        cambioSelccionAll,
        dataf,
        isSeleccionable,
        cambioCampo,
        accionesFila
    } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    return (
        // <TableRow>
        <React.Fragment>
            {/* {isSeleccionable &&
            <StyledTableCell padding="checkbox" >
              <Checkbox
                indeterminate={dataf.some(row => row.isSelecciondo) && !dataf.every(row => row.isSelecciondo == true)}
                checked={dataf.every(row => row.isSelecciondo == true)}
                onChange={cambioSelccionAll}
              />
            </StyledTableCell>
          } */}
            {DetailByrow != null && <StyledTableCell padding="checkbox" />}
            {columns.map((column, ncolumna) => (
                <StyledTableCell
                    key={'header' + column.name}
                    padding={column.disablePadding ? 'none' : 'default'}
                    sortDirection={orderBy === column.name ? order : false}
                >
                    <div style={{ width: '100%' }}>
                        {!column.filtrar ? (
                            <Button fullWidth onClick={createSortHandler(column.name)}>
                                {column.label}
                                <TableSortLabel
                                    active={orderBy === column.name}
                                    direction={orderBy === column.name ? order : 'asc'}

                                    // style={{ minWidth:'4em' }}
                                ></TableSortLabel>
                            </Button>
                        ) : typeof column.filtrar !== 'object' ? (
                            <TextField
                                fullWidth
                                size="small"
                                placeholder={column.label}
                                onChange={cambioCampo(column.name)}
                                value={filtros != null ? filtros[column.name] : null}
                                style={{ minWidth: (column.tamano ? column.tamano : column.label.length)+ 'rem'}}
                                // style={{ minWidth: (filtros.espesificos[column.name]?.length || column.label.length) + 'rem' , fontSize: 8 }}
                                //style={{minWidth:(column.tamano ? column.tamano : filtros.espesificos[column.name]?.length || column.label.length) + 'rem' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <TableSortLabel
                                                active={orderBy === column.name}
                                                direction={orderBy === column.name ? order : 'asc'}
                                                onClick={createSortHandler(column.name)}
                                                // style={{ minWidth:'4em' }}
                                            ></TableSortLabel>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        ) : (
                            <TextField
                                select
                                fullWidth
                                size="small"
                                placeholder={column.label}
                                onChange={cambioCampo(column.name)}
                                SelectProps={{ native: true }}
                                style={{ minWidth: column.label.length+ 'rem'}}
                                //style={{ minWidth: (filtros.espesificos[column.name]?.length || column.label.length) + 'rem' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <TableSortLabel
                                                active={orderBy === column.name}
                                                direction={orderBy === column.name ? order : 'asc'}
                                                onClick={createSortHandler(column.name)}
                                                // style={{ minWidth:'4em' }}
                                            ></TableSortLabel>
                                        </InputAdornment>
                                    )
                                }}
                            >
                                <option></option>
                                {column.filtrar.ctl.map((opcion, index) => (
                                    <option key={index}>{opcion[column.filtrar.value]}</option>
                                ))}
                            </TextField>
                        )}
                    </div>
                </StyledTableCell>
            ))}
            {accionesFila.length > 0 && <StyledTableCell padding="checkbox" />}
        </React.Fragment>
        // </TableRow>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default EnhancedTableHead;
